import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IClub888IconProps extends ISvgIconProps {

}

export class Club888Icon extends React.Component<IClub888IconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M3.749,5.431c2.07,0,3.749,1.678,3.749,3.749s-1.678,3.749-3.749,3.749S0,11.25,0,9.18c0,0,0,0,0,0
                        C0.002,7.11,1.679,5.433,3.749,5.431z M3.749,11.035c1.025,0,1.855-0.831,1.855-1.856c0-1.025-0.831-1.855-1.855-1.855
                        S1.893,8.155,1.893,9.18l0,0C1.895,10.204,2.725,11.033,3.749,11.035z"/>
                    <path d="M3.749,11.071c2.07,0,3.749,1.678,3.749,3.749s-1.678,3.749-3.749,3.749S0,16.891,0,14.82
                        C0.002,12.751,1.679,11.073,3.749,11.071z M3.749,16.676c1.025,0,1.855-0.831,1.855-1.856c0-1.025-0.831-1.855-1.855-1.855
                        s-1.855,0.831-1.855,1.856l0,0C1.895,15.844,2.725,16.674,3.749,16.676z"/>
                    <path d="M12.001,5.431c2.07,0,3.749,1.678,3.749,3.749s-1.678,3.749-3.749,3.749S8.252,11.25,8.252,9.18v0
                        C8.254,7.11,9.931,5.433,12.001,5.431z M12.001,11.035c1.025,0,1.856-0.831,1.856-1.855s-0.831-1.855-1.855-1.855
                        s-1.856,0.831-1.856,1.855v0C10.147,10.204,10.977,11.033,12.001,11.035z"/>
                    <path d="M12.001,11.071c2.07,0,3.749,1.678,3.749,3.749s-1.678,3.749-3.749,3.749s-3.749-1.678-3.749-3.749
                        C8.254,12.751,9.931,11.073,12.001,11.071z M12.001,16.676c1.025,0,1.856-0.831,1.856-1.855s-0.831-1.856-1.855-1.856
                        s-1.856,0.831-1.856,1.855v0C10.147,15.844,10.977,16.674,12.001,16.676z"/>
                    <path d="M20.251,5.431C22.322,5.431,24,7.109,24,9.18s-1.678,3.749-3.749,3.749s-3.749-1.678-3.749-3.749c0,0,0,0,0,0
                        C16.504,7.11,18.181,5.433,20.251,5.431z M20.251,11.035c1.025,0,1.855-0.831,1.855-1.856c0-1.025-0.831-1.855-1.855-1.855
                        c-1.025,0-1.855,0.831-1.855,1.855C18.397,10.204,19.227,11.033,20.251,11.035z"/>
                    <path d="M20.251,11.071c2.07,0,3.749,1.678,3.749,3.749s-1.678,3.749-3.749,3.749s-3.749-1.678-3.749-3.749l0,0
                        C16.504,12.751,18.181,11.073,20.251,11.071z M20.251,16.676c1.025,0,1.855-0.831,1.855-1.856c0-1.025-0.831-1.855-1.855-1.855
                        c-1.025,0-1.855,0.831-1.855,1.856C18.397,15.844,19.227,16.674,20.251,16.676z"/>
                </g>
            </SvgIcon>
        );
    }
}
